import React, { useEffect } from 'react';

import '../../static/css/main.css'
import '../../static/fonts/stylesheet.css'

import { MainCalc } from '../calc/mainCalc';
import { CalculateInsurance } from '../precalc/calcInsurance';
import { useDispatch, useSelector } from 'react-redux';
import { selectCalcPage } from './homeSlice';
import { Login } from '../login/login';
import { useParams } from 'react-router-dom';
import { setMortgageBalance } from '../precalc/precalcSlice';
import { setIdBank, setTypeObject } from '../calc/calcSlice';
import { TYPES_OBJECTS } from '../../static/vars';

export function Home() {
    const dispatch = useDispatch()
    let { a } = useParams();
    let { b } = useParams();
    let { c } = useParams();
    const calcPage = useSelector(selectCalcPage)

    useEffect(() => {
        console.log('hiddenAmount', a)
        if (a) dispatch(setMortgageBalance(a))
        if (b) dispatch(setIdBank(b))
        const n_c = parseInt(c)
        if (n_c) dispatch(setTypeObject(TYPES_OBJECTS[n_c-1].text))
    }, []);
    return (
        <>
            <div className="App">
                {calcPage === 'precalc' && <CalculateInsurance id_bank={b} limit_sum={a}/>}
                {calcPage === 'calc' && <MainCalc/>}
            </div>
        </>
    );
}



